export default __webpack_public_path__ + "static/signature-3dbbe429b401e2f96c372285c4190ae5.gif";